import { Injectable } from '@angular/core';
import { Dataset } from '../store/models/dataset.model';
import { FieldDataType, SchemaField, SystemFieldNames } from '../store/models/document.model';

@Injectable({ providedIn: 'root' })
export class DatasetService {
  getTranslatableFields(dataset?: Dataset): SchemaField[] {
    if (dataset?.hasTranslations === true) {
      return dataset?.schema?.fields?.filter(f => f.dataType === FieldDataType.Text && f.systemName != 'external_id');
    } else {
      return dataset?.schema?.fields?.filter(f => f.settings?.translatable === true);
    }
  }

  hasTranslations(dataset?: Dataset): boolean {
    if (dataset?.hasTranslations === true) {
      return true;
    } else {
      return dataset?.schema?.fields?.some(f => f.settings?.translatable === true);
    }
  }
}
